import React from 'react';

import { inspectionAPI } from 'api/requests';

import FilePicker from 'Components/FilePicker';

export default function ResponseDocumentation({ varDocuments, id }) {
  return (
    <section className='scene_section'>
      <header>Variation Response Documentation</header>
      <div className='__main-alert-label'>Please upload Variation Response and supporting documentation if any.</div>
      <FilePicker
        editableStateSectionHeader=''
        notEditableStateSectionHeader=''
        isEditable={false}
        sectionHeaderClassName='_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16'
        mainWrapperClassName='_min_height_auto'
        uploadButtonText='Upload'
        httpParams={{ currentMethod: inspectionAPI.downloadResponseDocument, currentId: id }}
        files={varDocuments || []}
      />
    </section>
  );
}

ResponseDocumentation.defaultProps = {
  varDocuments: [],
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Response/ResponseDocumentation.jsx